module.exports = __webpack_public_path__ + "static/speed-client@2x-32db5dc13f4aa98649b696a0555ffca1.png";